// extracted by css-extract-rspack-plugin
export default {"label":"_be33e1df","link":"_21c37cd9"};